export default __webpack_public_path__ + "assets/img/organization.a3aace6a060c85523ecc1bf10a96261c.png";